<template lang="pug">
.error-modal
  v-dialog(
    :value="dialog",
    hide-overlay,
    @input="close"
    width="650"
  )
    v-card
      v-container
        v-row.justify-center
          v-icon.error-modal__close(@click="close") mdi-close
          v-icon.error-modal__icon mdi-clipboard-text
        v-row
          v-col.error-modal__display
            h2.font-weight-regular {{$t('Common.errorModal')}}:
        v-row
          v-col.error-modal__display.py-0
            app-entity-display(
              :value="displayObject",
              errorStyle,
              keyClass="h7",
              valueClass="h8",
              :background="false",
              :showHeader="false",
              :close="false",
              :edit="false",
            )
              template(v-slot:item="{ keyClass, key }")
                div(:class="keyClass") {{ reducedPath(key) }}
</template>

<style lang="stylus" scoped>
.error-modal__icon {
  color: red;
  font-size: 60px;
  padding-bottom: 5px;
}
.error-modal__display {
  padding-right: 90px;
  padding-left: 90px;
  .entity-display {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
.error-modal__close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 25px;
}
</style>

<script>
export default {
  name: 'ErrorModal',
  data: () => ({}),
  computed: {
    dialog() {
      return this.$store.state.errorModal;
    },
    displayObject() {
      return this.$store.state.errors || {};
    },
  },
  methods: {
    close() {
      this.$store.commit('SET_ERROR_MODAL', false)
    },
    reducedPath(string) {
      if (!string) return string;
      return this.$camelToString(string.split('.')[0]);
    }
  },
}
</script>
